import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  _id: 0,
  nameBadge: "Explorador Inicial",
  description: "",
  iconURL: "",
  type: "",
  goalValue: "",
  membreshipReq: "",
};

const badgeSlice = createSlice({
  name: "badge",
  initialState,
  reducers: {
    setBadge: (state, action) => {
      state._id = action.payload._id ?? 0;
      state.nameBadge = action.payload.nameBadge ?? "Explorador Inicial";
      state.description =
        action.payload.description ??
        "Eres nuevo en Radaria, ¡comienza a explorar!";
      state.goalValue = action.payload.goalValue ?? 0;
      state.iconURL = action.payload.iconURL ?? "";
      state.membreshipReq = action.payload.membreshipReq ?? "Free";
      state.type = action.payload.type ?? "explorer";
    },
    clearBadge: (state) => {
      state._id = 0;
      state.nameBadge = "Explorador Inicial";
    },
  },
});

export const { setBadge, clearBadge } = badgeSlice.actions;
export default badgeSlice.reducer;
